import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { Layout } from '@utilities';

import ModalBuildNarrative from '../Narratives/components/ModalBuildNarrative';
import NarrativeFlowView from '../../components/NarrativeFlowView';
import Page from '../../layouts/Page';

const Narrative = () => {
  const { flow_id: flowId } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <NarrativeFlowView
      flowId={flowId}
      onReprompt={() => setIsModalOpen(true)}
      renderAfterContent={({ flow, narrativeRoute }) =>
        isModalOpen ? (
          <ModalBuildNarrative
            flowId={flow?.id}
            route={narrativeRoute}
            setIsModalOpen={setIsModalOpen}
          />
        ) : null
      }
    />
  );
};

const NarrativeLayout = () => (
  <Page>
    <Layout.Column>
      <Narrative />
    </Layout.Column>
  </Page>
);

export default NarrativeLayout;
